import { render, staticRenderFns } from "./PassportPdf.vue?vue&type=template&id=9fc9ea2c&"
import script from "./PassportPdf.vue?vue&type=script&lang=js&"
export * from "./PassportPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports